export const BusinessLocationsRegistry: Record<string, string[]> = {
    DZ: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    AO: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    BJ: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    BW: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    BF: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    CM: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    TD: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    KM: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    CG: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    CD: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    CI: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    ET: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    GA: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    GM: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    GH: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    GN: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    KE: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    LS: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    LY: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    MW: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    ML: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    MU: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    YT: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    MA: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    MZ: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    NA: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    NG: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    RE: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    RW: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    SN: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    ZA: ['Europe, Israel & Africa', 'Africa', 'South Africa', 'South Africa'],
    TZ: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    TN: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    UG: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    ZM: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    ZW: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    EG: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    BH: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    IQ: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    JO: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    KW: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    LB: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    OM: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    PK: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    PS: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    QA: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    SA: ['APJ & ME', 'Middle East', 'Middle East', 'Saudi Arabia'],
    AE: ['APJ & ME', 'Middle East', 'Middle East', 'United Arab Emirates'],
    YE: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    AT: ['Europe, Israel & Africa', 'DACH', 'DACH', 'Austria'],
    DE: ['Europe, Israel & Africa', 'DACH', 'DACH', 'Germany'],
    LI: ['Europe, Israel & Africa', 'DACH', 'DACH', 'Liechtenstein'],
    CH: ['Europe, Israel & Africa', 'DACH', 'DACH', 'Switzerland'],
    IL: ['Europe, Israel & Africa', 'Israel', 'Israel', 'Israel'],
    BE: ['Europe, Israel & Africa', 'BENELUX', 'BENELUX', 'Belgium - Luxembourg'],
    LU: ['Europe, Israel & Africa', 'BENELUX', 'BENELUX', 'Belgium - Luxembourg'],
    NL: ['Europe, Israel & Africa', 'BENELUX', 'BENELUX', 'Netherlands'],
    DK: ['Europe, Israel & Africa', 'Northern Europe', 'Nordics', 'Nordics'],
    FO: ['Europe, Israel & Africa', 'Northern Europe', 'Nordics', 'Nordics'],
    FI: ['Europe, Israel & Africa', 'Northern Europe', 'Nordics', 'Nordics'],
    IS: ['Europe, Israel & Africa', 'Northern Europe', 'Nordics', 'Nordics'],
    NO: ['Europe, Israel & Africa', 'Northern Europe', 'Nordics', 'Nordics'],
    SE: ['Europe, Israel & Africa', 'Northern Europe', 'Nordics', 'Nordics'],
    IE: ['Europe, Israel & Africa', 'Northern Europe', 'UK - Ireland', 'Ireland'],
    GB: ['Europe, Israel & Africa', 'Northern Europe', 'UK - Ireland', 'United Kingdom'],
    AL: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    AM: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    BA: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    HR: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    KZ: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    MK: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    MD: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    MN: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    ME: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    RS: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    SI: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    BG: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    CY: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    GR: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    MT: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    RO: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    TR: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Turkey'],
    CZ: ['Europe, Israel & Africa', 'Rest of Europe', 'Eastern Europe', 'Rest of Eastern Europe'],
    EE: ['Europe, Israel & Africa', 'Rest of Europe', 'Eastern Europe', 'Rest of Eastern Europe'],
    HU: ['Europe, Israel & Africa', 'Rest of Europe', 'Eastern Europe', 'Rest of Eastern Europe'],
    LV: ['Europe, Israel & Africa', 'Rest of Europe', 'Eastern Europe', 'Rest of Eastern Europe'],
    LT: ['Europe, Israel & Africa', 'Rest of Europe', 'Eastern Europe', 'Rest of Eastern Europe'],
    PL: ['Europe, Israel & Africa', 'Rest of Europe', 'Eastern Europe', 'Poland'],
    SK: ['Europe, Israel & Africa', 'Rest of Europe', 'Eastern Europe', 'Rest of Eastern Europe'],
    UA: ['Europe, Israel & Africa', 'Rest of Europe', 'Eastern Europe', 'Rest of Eastern Europe'],
    FR: ['Europe, Israel & Africa', 'Rest of Europe', 'France', 'France'],
    GI: ['Europe, Israel & Africa', 'Rest of Europe', 'Iberia', 'Rest of Iberia'],
    PT: ['Europe, Israel & Africa', 'Rest of Europe', 'Iberia', 'Rest of Iberia'],
    ES: ['Europe, Israel & Africa', 'Rest of Europe', 'Iberia', 'Spain'],
    IT: ['Europe, Israel & Africa', 'Rest of Europe', 'Italy', 'Italy'],
    SM: ['Europe, Israel & Africa', 'Rest of Europe', 'Italy', 'Italy'],
    AU: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    FJ: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    NC: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    NZ: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    PG: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    WS: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    ID: ['APJ & ME', 'APAC', 'South East Asia', 'Indonesia'],
    MY: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    PH: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    TH: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    KH: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    MM: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    VN: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    CN: ['APJ & ME', 'APAC', 'GCR', 'GCR'],
    HK: ['APJ & ME', 'APAC', 'GCR', 'GCR'],
    TW: ['APJ & ME', 'APAC', 'GCR', 'GCR'],
    IN: ['APJ & ME', 'APAC', 'India and South Asia', 'India'],
    BD: ['APJ & ME', 'APAC', 'India and South Asia', 'South Asia'],
    MV: ['APJ & ME', 'APAC', 'India and South Asia', 'South Asia'],
    NP: ['APJ & ME', 'APAC', 'India and South Asia', 'South Asia'],
    LK: ['APJ & ME', 'APAC', 'India and South Asia', 'South Asia'],
    KR: ['APJ & ME', 'APAC', 'Korea', 'Korea'],
    SG: ['APJ & ME', 'APAC', 'Singapore', 'Singapore'],
    JP: ['APJ & ME', 'Japan', 'Japan', 'Japan'],
    BR: ['Americas', 'LATAM', 'Brazil', 'Brazil'],
    AW: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    BS: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    BB: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    BM: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    CR: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    DM: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    DO: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    SV: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    GF: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    GP: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    GT: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    HN: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    JM: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    MQ: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    NI: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    PA: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    LC: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    VC: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    SR: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    TT: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    VE: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    CO: ['Americas', 'LATAM', 'Northern LATAM', 'Colombia'],
    MX: ['Americas', 'LATAM', 'Northern LATAM', 'Mexico'],
    AR: ['Americas', 'LATAM', 'Southern LATAM', 'Rest of Southern LATAM'],
    BO: ['Americas', 'LATAM', 'Southern LATAM', 'Rest of Southern LATAM'],
    CL: ['Americas', 'LATAM', 'Southern LATAM', 'Chile'],
    EC: ['Americas', 'LATAM', 'Southern LATAM', 'Rest of Southern LATAM'],
    PY: ['Americas', 'LATAM', 'Southern LATAM', 'Rest of Southern LATAM'],
    PE: ['Americas', 'LATAM', 'Southern LATAM', 'Peru'],
    UY: ['Americas', 'LATAM', 'Southern LATAM', 'Rest of Southern LATAM'],
    CA: ['Americas', 'North America', 'North America', 'Canada'],
    PR: ['Americas', 'North America', 'North America', 'United States'],
    US: ['Americas', 'North America', 'North America', 'United States'],
    AI: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    AG: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    BZ: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    KY: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    CU: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    CW: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    FK: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    GD: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    GY: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    HT: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    MS: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    AN: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    BL: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    KN: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    MF: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    PM: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    BQ: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    SX: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    TC: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    UM: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    VG: ['Americas', 'LATAM', 'Northern LATAM', 'Caribbean and Central America'],
    AQ: ['Americas', 'LATAM', 'Southern LATAM', 'Rest of Southern LATAM'],
    GS: ['Americas', 'LATAM', 'Southern LATAM', 'Rest of Southern LATAM'],
    VI: ['Americas', 'North America', 'North America', 'United States'],
    AS: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    CK: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    PF: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    GU: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    HM: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    KI: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    MH: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    FM: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    NR: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    NU: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    NF: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    MP: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    PW: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    PN: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    SB: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    TL: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    TK: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    TO: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    VU: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    WF: ['APJ & ME', 'APAC', 'ANZ', 'ANZ'],
    BN: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    CX: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    CC: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    TP: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    LA: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    TV: ['APJ & ME', 'APAC', 'South East Asia', 'Rest of South East Asia'],
    MO: ['APJ & ME', 'APAC', 'GCR', 'GCR'],
    BT: ['APJ & ME', 'APAC', 'India and South Asia', 'South Asia'],
    IO: ['APJ & ME', 'APAC', 'India and South Asia', 'South Asia'],
    KP: ['APJ & ME', 'APAC', 'Korea', 'Korea'],
    AC: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    BV: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    BI: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    CV: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    CF: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    DJ: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    GQ: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    ER: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    TF: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    GW: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    LR: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    MG: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    MR: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    NE: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    SH: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    ST: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    SC: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    SL: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    SO: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    SD: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    SZ: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    TG: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    EH: ['Europe, Israel & Africa', 'Africa', 'Rest of Africa', 'Rest of Africa'],
    AF: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    IR: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    SY: ['APJ & ME', 'Middle East', 'Middle East', 'Rest of Middle East'],
    AX: ['Europe, Israel & Africa', 'Northern Europe', 'Nordics', 'Nordics'],
    GL: ['Europe, Israel & Africa', 'Northern Europe', 'Nordics', 'Nordics'],
    SJ: ['Europe, Israel & Africa', 'Northern Europe', 'Nordics', 'Nordics'],
    GG: ['Europe, Israel & Africa', 'Northern Europe', 'UK - Ireland', 'United Kingdom'],
    IM: ['Europe, Israel & Africa', 'Northern Europe', 'UK - Ireland', 'United Kingdom'],
    JE: ['Europe, Israel & Africa', 'Northern Europe', 'UK - Ireland', 'United Kingdom'],
    AZ: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    BY: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    GE: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    XK: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    KG: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    TJ: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    TM: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    UZ: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    YU: ['Europe, Israel & Africa', 'Rest of Europe', 'Balkans - Turkey - Mediterranean - CIS', 'Balkans - Mediterranean - CIS'],
    AD: ['Europe, Israel & Africa', 'Rest of Europe', 'France', 'France'],
    MC: ['Europe, Israel & Africa', 'Rest of Europe', 'France', 'France'],
    IC: ['Europe, Israel & Africa', 'Rest of Europe', 'Iberia', 'Spain'],
    VA: ['Europe, Israel & Africa', 'Rest of Europe', 'Italy', 'Italy'],
    RU: ['Russia', 'Russia', 'Russia', 'Russia'],
};
